import axiosIns from '@/libs/axios'

const ROOT_URL = '/position-guardian'

export default {
  namespaced: true,
  state: {
    overview: { positions: [], counts: {}, closeFollow: [] },
    targets: [],
    decisions: [],
    insurance: { accounts: [], events: [] },
    saveStatus: { status: null, message: null },
  },
  getters: {
    overview: s => s.overview,
    targets: s => s.targets,
    decisions: s => s.decisions,
    insurance: s => s.insurance,
    saveStatus: s => s.saveStatus,
  },
  mutations: {
    SET_OVERVIEW(state, data) { state.overview = data || { positions: [], counts: {}, closeFollow: [] } },
    SET_TARGETS(state, data) { state.targets = data || [] },
    SET_DECISIONS(state, data) { state.decisions = data || [] },
    SET_INSURANCE(state, data) { state.insurance = data || { accounts: [], events: [] } },
    SET_SAVE_STATUS(state, data) { state.saveStatus = data },
  },
  actions: {
    getOverview({ commit }) {
      return axiosIns.get(`${ROOT_URL}/overview`)
        .then(response => { commit('SET_OVERVIEW', response.data.data); return response.data.data })
    },
    getTargets({ commit }) {
      return axiosIns.get(`${ROOT_URL}/targets`)
        .then(response => { commit('SET_TARGETS', response.data.data); return response.data.data })
    },
    updateTarget({ commit, dispatch }, { id, body }) {
      return axiosIns.patch(`${ROOT_URL}/targets/${id}`, body)
        .then(response => {
          commit('SET_SAVE_STATUS', { status: true, message: 'Guardian hedef ayarı güncellendi.' })
          dispatch('getTargets')
          dispatch('getOverview')
          return response.data.data
        })
    },
    tuneTarget({ commit, dispatch }, { id, body }) {
      return axiosIns.post(`${ROOT_URL}/targets/${id}/tune`, body || {})
        .then(response => {
          commit('SET_SAVE_STATUS', {
            status: true,
            message: response.data.data && response.data.data.applied
              ? 'Guardian auto-tune uygulandı.'
              : 'Guardian auto-tune önerisi üretildi.',
          })
          dispatch('getTargets')
          dispatch('getOverview')
          return response.data.data
        })
    },
    getDecisions({ commit }, limit = 100) {
      return axiosIns.get(`${ROOT_URL}/decisions`, { params: { limit } })
        .then(response => { commit('SET_DECISIONS', response.data.data); return response.data.data })
    },
    getInsurance({ commit }) {
      return axiosIns.get(`${ROOT_URL}/insurance`)
        .then(response => { commit('SET_INSURANCE', response.data.data); return response.data.data })
    },
    applyDecision({ dispatch }, id) {
      return axiosIns.post(`${ROOT_URL}/decisions/${id}/apply`)
        .then(response => {
          dispatch('getDecisions')
          dispatch('getOverview')
          return response.data.data
        })
    },
    closePosition({ dispatch }, positionId) {
      return axiosIns.post(`${ROOT_URL}/positions/${positionId}/close`)
        .then(response => {
          dispatch('getOverview')
          dispatch('getDecisions')
          return response.data.data
        })
    },
    updateStops({ dispatch }, { positionId, body }) {
      return axiosIns.patch(`${ROOT_URL}/positions/${positionId}/stops`, body)
        .then(response => {
          dispatch('getOverview')
          dispatch('getDecisions')
          return response.data.data
        })
    },
  },
}
